import serverCall from "../serverCall";

// Bulk wake devices matching a filter (country/network/online/verified/number).
// Backend: POST /admin/notify-filter → { matched, notified }.
const notifyByFilter = (filters) => {
  return serverCall.post(`/admin/notify-filter`, filters);
};

const NotifyService = {
  notifyByFilter,
};

export default NotifyService;
